import { buildTask as _buildTask } from "ember-concurrency/async-arrow-runtime";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _AuthenticationLogin;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from '@ember/object';
import { on } from '@ember/modifier';
import { fn } from '@ember/helper';
import TestEnvFeature from 'core/components/test-env-feature';
import { service } from '@ember/service';
import { dasherize } from '@ember/string';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import ParogService from 'core/services/parog';
import SemeiaSessionService from 'core/services/session';
import AuthUtils from 'core/utils/authentication';
import LoginValidations from 'core/validations/login';
import TwoFactorValidations from 'core/validations/twoFactorAuth';
import { Changeset, EmberChangeset } from 'ember-changeset';
import { task } from 'ember-concurrency';
import perform from 'ember-concurrency/helpers/perform';
import emberSwal from 'ui-kit/utils/ember-swal';
import { lookupValidator } from 'validated-changeset';
import WrButton from 'ember-wiser/components/wr/button';
import changesetSet from 'ember-changeset/helpers/changeset-set';
import WrForm from 'ember-wiser/components/wr/form';
import WrLinkTo from 'ember-wiser/components/wr/link-to';
import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
let AuthenticationLogin = (_class = (_AuthenticationLogin = class AuthenticationLogin extends Component {
  get shouldDisplaySendBackCodeLink() {
    return !this.codeHasBeenSentBack && !this.loginTask.isRunning;
  }
  onSendBackClick() {
    this.codeHasBeenSentBack = true;
    this.sendBackAuthCode();
  }
  constructor(owner1, args1) {
    super(owner1, args1);
    _initializerDefineProperty(this, "twoFactorRequired", _descriptor, this);
    _initializerDefineProperty(this, "loginSuccessful", _descriptor2, this);
    _initializerDefineProperty(this, "errorMessage", _descriptor3, this);
    _defineProperty(this, "loginChangeset", void 0);
    _defineProperty(this, "twoFactorChangeset", void 0);
    _defineProperty(this, "authenticator", void 0);
    _initializerDefineProperty(this, "session", _descriptor4, this);
    _initializerDefineProperty(this, "parog", _descriptor5, this);
    _initializerDefineProperty(this, "codeHasBeenSentBack", _descriptor6, this);
    _defineProperty(this, "loginTask", _buildTask(() => ({
      context: this,
      generator: function* () {
        this.args.onLoading?.(true);
        try {
          yield this.session.authenticate(this.authenticator, this.credentials);
          this.loginSuccessful = true;
          // No action should be done after `authenticate` as Ember Simple Auth
          // automatically transitions to the configured route (index by default).
        } catch (error1) {
          this.loginSuccessful = false;
          const {
            reason: reason1
          } = error1;
          if (reason1?.status === 401) {
            const twoFactorStatus1 = reason1.headers.get(dasherize(AuthUtils.twoFactorHeaderKey));
            if (twoFactorStatus1 === 'required') {
              // A 2FA can be required if our token has expired
              AuthUtils.clear2faTokenInStorage(this.credentials.email);
              this.twoFactorRequired = true;
            } else if (twoFactorStatus1 === 'invalid') {
              this.errorMessage = 'Verification code is missing, invalid or expired';
              emberSwal.fire('Oops !', 'Code de vérification invalide.', 'error');
            } else {
              this.errorMessage = reason1.body;
              emberSwal.fire('Oops !', 'Email ou mot de passe invalide.', 'error');
            }
          } else if (reason1?.status === 429) {
            const retryAfter1 = reason1.headers.get('retry-after');
            emberSwal.fire('Attention.', `Vous avez effectué trop de tentatives de connexion. Veuillez attendre ${retryAfter1} secondes et réessayer.`, 'error');
          } else {
            // Re-throw errors other than "bad credentials" to get them in Sentry.
            throw error1;
          }
        } finally {
          this.args.onLoading?.(false);
        }
      }
    }), null, "loginTask", null));
    _defineProperty(this, "passwordForgottenRoute", `login.${this.args.userType}-password-forgotten`);
    this.authenticator = this.args.userType == 'medic' ? 'authenticator:medics-password' : 'authenticator:patients-password';
    const model1 = {};
    this.loginChangeset = Changeset(model1, lookupValidator(LoginValidations), LoginValidations);
    this.twoFactorChangeset = Changeset(model1, lookupValidator(TwoFactorValidations), TwoFactorValidations);
  }
  get data() {
    const data1 = this.twoFactorRequired ? this.twoFactorChangeset : this.loginChangeset;
    return data1;
  }
  get credentials() {
    const creds1 = {
      email: this.loginChangeset.get('email'),
      password: this.loginChangeset.get('password'),
      twoFactorCode: this.twoFactorChangeset.get('twoFactorCode'),
      twoFactorToken: AuthUtils.get2faTokenFromStorage(this.loginChangeset.get('email'))
    };
    if (this.args.userType == 'medic') {
      Object.assign(creds1, {
        browserAuthToken: AuthUtils.getBrowserAuthToken(this.loginChangeset.get('email'))
      });
    }
    return creds1;
  }
  get isLoggingIn() {
    return this.loginSuccessful || this.loginTask.isRunning;
  }
  async sendBackAuthCode() {
    const credentials1 = this.credentials;
    // Don't send the twoFactorCode to generate a new code.
    delete credentials1.twoFactorCode;
    try {
      await this.session.authenticate(this.authenticator, credentials1);
    } catch {
      emberSwal.fire({
        title: 'Un nouveau code vous a été envoyé.',
        text: 'Vérifier vos email et vos SMS.',
        icon: 'success'
      });
    }
  }
  get magicLinkEmails() {
    const magicLinkDeduppers1 = ['+nw', '+ow', '+mw', '+rw'];
    if (this.args.userType == 'medic') {
      return magicLinkDeduppers1.flatMap(dedupper1 => ['doctor', 'nurse'].map(e1 => `${e1}${dedupper1}@semeia.io`));
    }
    return magicLinkDeduppers1.map(e1 => `patient-zero${e1}@semeia.io`);
  }
}, setComponentTemplate(precompileTemplate("\n    <WrForm @data={{this.data}} @onSubmit={{perform this.loginTask}} class=\"mx-auto flex w-full flex-col items-stretch gap-6 pb-2 sm:w-[355px]\" as |form|>\n      {{#if this.twoFactorRequired}}\n        <p>\n          Vous avez re\xE7u un code \xE0 4 chiffres par SMS ou par email. Merci de le\n          renseigner ici&nbsp;:\n        </p>\n\n        <form.Input @name=\"twoFactorCode\" type=\"password\" placeholder=\"Code de s\xE9curit\xE9\" aria-label=\"Code de s\xE9curit\xE9\" data-test-login=\"2faCode\" />\n\n        <p>\n          <span class=\"time-label\">\n            Vous n'avez pas re\xE7u de SMS ni d'email ?\n          </span>\n          {{#if this.shouldDisplaySendBackCodeLink}}\n            <WrButton @variant=\"anchor\" data-test-send-back-auth-code {{on \"click\" this.onSendBackClick}}>\n              Renvoyer le code\n            </WrButton>\n          {{/if}}\n        </p>\n\n        <p class=\"time-label\">\n          En cas de probl\xE8me, vous pouvez contacter le support de S\xEAmeia du\n          lundi au vendredi entre 9h et 18h au\n          <a href=\"mailto:ide@semeia.io?subject=Probl\xE8me authentification double facteur\">\n            ide@semeia.io\n          </a>\n        </p>\n      {{else}}\n        <form.Input @name=\"email\" aria-label=\"Votre adresse e-mail\" placeholder=\"Votre adresse e-mail\" autocomplete=\"username\" />\n\n        <form.Input @name=\"password\" type=\"password\" aria-label=\"Votre mot de passe\" placeholder=\"Votre mot de passe\" autocomplete=\"current-password\" />\n\n      {{/if}}\n\n      <form.SubmitButton @icon=\"ArrowRight\" class=\"self-center\">Se connecter</form.SubmitButton>\n\n      {{#unless this.twoFactorRequired}}\n        <WrLinkTo @route={{this.passwordForgottenRoute}} class=\"self-center\">\n          J\u2019ai oubli\xE9 mon mot de passe\n        </WrLinkTo>\n\n        <TestEnvFeature>\n          <div class=\"text-center\">\n            {{#each this.magicLinkEmails as |email|}}\n              <WrButton class=\"text-sm sm:text-base\" data-test-magic-link={{email}} type=\"submit\" @variant=\"anchor\" {{on \"click\" (fn (changesetSet this.loginChangeset \"email\") email)}} {{on \"click\" (fn (changesetSet this.loginChangeset \"password\") \"SEMEIApass!\")}}>\n                \u2728 Login as\n                {{email}}\n                \u2728\n              </WrButton>\n            {{/each}}\n          </div>\n        </TestEnvFeature>\n      {{/unless}}\n    </WrForm>\n  ", {
  strictMode: true,
  scope: () => ({
    WrForm,
    perform,
    WrButton,
    on,
    WrLinkTo,
    TestEnvFeature,
    fn,
    changesetSet
  })
}), _AuthenticationLogin), _AuthenticationLogin), _descriptor = _applyDecoratedDescriptor(_class.prototype, "twoFactorRequired", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "loginSuccessful", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "errorMessage", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "session", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "parog", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "codeHasBeenSentBack", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "onSendBackClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onSendBackClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sendBackAuthCode", [action], Object.getOwnPropertyDescriptor(_class.prototype, "sendBackAuthCode"), _class.prototype), _class);
export { AuthenticationLogin as default };